<template>
  <div class="lock-container">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>设备管理</el-breadcrumb-item>
      <el-breadcrumb-item>蓝牙门锁</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 搜索栏 -->
    <div class="search-bar">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="锁别名">
          <el-input v-model="formInline.lockAlias" placeholder="请输入锁别名" clearable></el-input>
        </el-form-item>
        <el-form-item label="店铺">
          <el-select 
            v-model="formInline.shop_id" 
            placeholder="请选择店铺"
            filterable
            clearable
            remote
            :remote-method="searchShops"
            :loading="shopLoading"
            style="width: 200px">
            <el-option 
              v-for="item in shopOptions" 
              :key="item.id" 
              :label="item.name" 
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开锁方式">
          <el-select v-model="formInline.is_gateway" placeholder="请选择开锁方式" clearable>
            <el-option label="网关模式" value="1"></el-option>
            <el-option label="蓝牙模式" value="-1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit" icon="el-icon-search">查询</el-button>
          <el-button @click="resetSearchForm" icon="el-icon-refresh">重置</el-button>
          <el-button type="success" @click="handleRefresh" icon="el-icon-refresh">刷新门锁</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 数据表格 -->
    <el-table
      :data="tableData"
      v-loading="loading"
      border
      style="width: 100%"
      stripe>
      <el-table-column prop="lockAlias" label="锁别名" min-width="150" align="center"></el-table-column>
    
      </el-table-column>
            <el-table-column prop="shop_name" label="店铺名称" min-width="150" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.shop_name || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="room_name" label="包厢名称" min-width="150" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.room_name || '-' }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="room_id" label="包厢ID" min-width="120" align="center"></el-table-column>
      <el-table-column prop="lockId" label="锁ID" min-width="150" align="center"></el-table-column>
      <el-table-column prop="electricQuantity" label="锁电量" min-width="100" align="center">
        <template slot-scope="scope">
          <el-tag :type="getBatteryType(scope.row.electricQuantity)">
            {{ scope.row.electricQuantity }}%
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="is_gateway" label="开锁方式" min-width="100" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.is_gateway === 1 ? 'primary' : 'success'">
            {{ scope.row.is_gateway === 1 ? '网关模式' : '蓝牙模式' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="100" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleEdit(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>

    <!-- 编辑对话框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="500px"
      :close-on-click-modal="false"
      @close="resetDialogForm">
      <el-form :model="form" :rules="rules" ref="lockForm" label-width="120px">
        <el-form-item label="锁别名" prop="lockAlias">
          <el-input v-model="form.lockAlias" placeholder="请输入锁别名" disabled></el-input>
        </el-form-item>
        <el-form-item label="锁ID" prop="lockId">
          <el-input v-model="form.lockId" placeholder="请输入锁ID" disabled></el-input>
        </el-form-item>
        <el-form-item label="店铺" prop="shop_id">
          <el-select 
            v-model="form.shop_id" 
            placeholder="请选择店铺"
            filterable
            clearable
            remote
            :remote-method="searchEditShops"
            :loading="editShopLoading"
            @change="handleEditShopChange"
            style="width: 100%">
            <el-option 
              v-for="item in editShopOptions" 
              :key="item.id" 
              :label="item.name" 
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="包厢" prop="room_id">
          <el-select 
            v-model="form.room_id" 
            placeholder="请先选择店铺"
            clearable
            style="width: 100%"
            :disabled="!form.shop_id">
            <el-option 
              v-for="item in editRoomOptions" 
              :key="item.id" 
              :label="item.name" 
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开锁方式" prop="is_gateway">
          <el-select v-model="form.is_gateway" placeholder="请选择开锁方式" style="width: 100%">
            <el-option label="网关模式" :value="1"></el-option>
            <el-option label="蓝牙模式" :value="-1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm" :loading="submitLoading">确 定</el-button>
      </div>
    </el-dialog>


  </div>
</template>

<script>
import { lock, editLock, refreshLock} from '@/api/device'
import { getShopList,getRoomList } from '@/api/shop'

export default {
  name: 'Lock',
  data() {
    return {
      tableData: [],
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      formInline: {
        lockAlias: '',
        shop_id: '',
        is_gateway: ''
      },
      dialogVisible: false,
      dialogTitle: '',
      form: {
        lockAlias: '',
        room_id: '',
        lockId: '',
        shop_id: '',
        is_gateway: 1,
        org_id:this.$globalConfig.orgId,
      },
      rules: {
        lockAlias: [
          { required: true, message: '请输入锁别名', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        room_id: [
          { required: true, message: '请选择包厢', trigger: 'change' }
        ],
        shop_id: [
          { required: true, message: '请选择店铺', trigger: 'change' }
        ],
        is_gateway: [
          { required: true, message: '请选择开锁方式', trigger: 'change' }
        ]
      },
      shopOptions: [],
      shopLoading: false,
      editShopOptions: [],
      editRoomOptions: [],
      editShopLoading: false,
      submitLoading: false,
      isEdit: false
    }
  },
  created() {
    this.loadData()
    this.loadShopsForSearch()
  },
  methods: {
    async loadData() {
      this.loading = true
      try {
        const params = {
          page: this.currentPage,
          limit: this.pageSize,
          ...this.formInline
        }
        const res = await lock(params)
        if (res.code === 1) {
          this.tableData = res.data.data || []
          this.total = res.data.total || 0
        } else {
          this.$message.error(res.data.message || '获取数据失败')
        }
      } catch (error) {
        this.$message.error('获取数据失败')
      } finally {
        this.loading = false
      }
    },
    onSubmit() {
      this.currentPage = 1
      this.loadData()
    },
    resetSearchForm() {
      this.formInline = {
        lockAlias: '',
        shop_id: '',
        is_gateway: ''
      }
      this.currentPage = 1 // 重置到第一页
      this.loadData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.loadData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.loadData()
    },
    async handleEdit(row) {
      this.isEdit = true
      this.dialogTitle = '编辑蓝牙锁'
      this.form = { ...row }
      
      try {
        // 并行加载：1. 已绑定店铺数据 2. 完整店铺列表
        const [allShopsRes] = await Promise.all([
          getShopList({ page: 1, limit: 100, org_id: this.$globalConfig.orgId })
        ])
        
        // 处理完整店铺列表
        if (allShopsRes.code === 1) {
          let allShops = []
          if (Array.isArray(allShopsRes.data)) {
            allShops = allShopsRes.data
          } else if (allShopsRes.data && Array.isArray(allShopsRes.data.data)) {
            allShops = allShopsRes.data.data
          } else if (allShopsRes.data && Array.isArray(allShopsRes.data.list)) {
            allShops = allShopsRes.data.list
          } else {
            allShops = allShopsRes.data || []
          }
          
          // 设置完整店铺列表
          this.editShopOptions = allShops
          
          // 如果门锁已绑定店铺，确保绑定数据在列表中
          if (row.shop_id && row.shop_name) {
            const boundShop = this.editShopOptions.find(shop => shop.id === row.shop_id)
            if (!boundShop) {
              // 将已绑定店铺添加到列表开头，确保可见性
              this.editShopOptions.unshift({
                id: row.shop_id,
                name: row.shop_name
              })
            }
          }
        }
        
        // 加载对应包厢列表
        if (row.shop_id) {
          await this.handleEditShopChange(row.shop_id)
        }
        
      } catch (error) {
        console.error('加载编辑数据失败:', error)
        this.$message.error('加载编辑数据失败')
      }
      
      this.dialogVisible = true
    },
    getBatteryType(quantity) {
      if (quantity >= 80) return 'success'
      if (quantity >= 50) return 'warning'
      return 'danger'
    },
    submitForm() {
      this.$refs.lockForm.validate(async (valid) => {
        if (valid) {
          this.submitLoading = true
          try {
            const apiMethod = this.isEdit ? editLock : lock
            const res = await apiMethod(this.form)
            if (res.code === 1) {
              this.$message.success(this.isEdit ? '编辑成功' : '新增成功')
              this.dialogVisible = false
              this.loadData()
            } else {
              this.$message.error(res.msg || '操作失败')
            }
          } catch (error) {
            this.$message.error('操作失败')
          } finally {
            this.submitLoading = false
          }
        }
      })
    },
    resetDialogForm() {
      this.$refs.lockForm && this.$refs.lockForm.resetFields()
    },
    async loadShopsForSearch() {
      try {
        console.log('开始加载搜索表单的店铺列表...')
        const res = await getShopList({ page: 1, limit: 100,org_id:this.$globalConfig.orgId, })
        console.log('搜索表单店铺列表接口返回:', res)
        
        if (res.code === 1) {
          // 处理可能的返回数据结构
          let shops = []
          if (Array.isArray(res.data)) {
            shops = res.data
          } else if (res.data && Array.isArray(res.data.data)) {
            shops = res.data.data
          } else if (res.data && Array.isArray(res.data.list)) {
            shops = res.data.list
          } else {
            shops = res.data || []
          }
          
          this.shopOptions = shops
          console.log('搜索表单店铺数据已加载:', this.shopOptions.length, '条', this.shopOptions)
        } else {
          this.$message.error(res.msg || '获取店铺列表失败')
          console.error('获取店铺列表失败:', res.message)
        }
      } catch (error) {
        console.error('获取店铺列表异常:', error)
        this.$message.error('获取店铺列表失败')
      }
    },
    async searchShops(query) {
      this.shopLoading = true
      try {
        const params = {
          name: query || undefined,
          page: 1,
          limit: 100,
          org_id:this.$globalConfig.orgId,
        }
        console.log('搜索店铺参数:', params)
        const res = await getShopList(params)
        console.log('搜索店铺结果:', res)
        
        if (res.code === 1) {
          // 处理可能的返回数据结构
          let shops = []
          if (Array.isArray(res.data)) {
            shops = res.data
          } else if (res.data && Array.isArray(res.data.data)) {
            shops = res.data.data
          } else if (res.data && Array.isArray(res.data.list)) {
            shops = res.data.list
          } else {
            shops = res.data || []
          }
          
          this.shopOptions = shops
          console.log('搜索到的店铺数量:', this.shopOptions.length, this.shopOptions)
        } else {
          this.$message.error(res.msg || '获取店铺列表失败')
          console.error('搜索店铺失败:', res.message)
        }
      } catch (error) {
        console.error('搜索店铺异常:', error)
        this.$message.error('获取店铺列表失败')
      } finally {
        this.shopLoading = false
      }
    },
    async handleRefresh() {
      let loading = null
      try {
        loading = this.$loading({
          lock: true,
          text: '正在刷新门锁列表...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        
        let page = 1
        let totalRefreshed = 0
        let hasError = false
        
        while (true) {
          try {
            // 检查loading是否被用户手动关闭
            if (!loading || loading.closed) {
              console.log('刷新被中断，停止请求')
              break
            }
            
            const res = await refreshLock({ page })
            
            if (res.code === 1) {
              const data = res.data.list || []
              if (data.length === 0) {
                // 数据为空，正常结束
                break
              }
              
              totalRefreshed += data.length
              page += 1
              
              // 更新loading文本显示进度
              if (loading && !loading.closed) {
                loading.text = `正在刷新门锁列表...已获取${totalRefreshed}条数据`
              }
              
              // 添加短暂延迟，避免请求过快
              await new Promise(resolve => setTimeout(resolve, 100))
            } else {
              this.$message.error(`第${page}页刷新失败: ${res.msg || '未知错误'}`)
              hasError = true
              break
            }
          } catch (error) {
            console.error('刷新中断:', error)
            hasError = true
            break
          }
        }
        
        // 关闭loading提示
        if (loading && !loading.closed) {
          loading.close()
        }
        
        // 无论是否中断，都重新加载当前列表数据
        await this.loadData()
        
        // 根据结果给出相应提示
        if (totalRefreshed > 0 && !hasError) {
          this.$message.success(`门锁列表刷新完成，共获取${totalRefreshed}条数据`)
        } else if (totalRefreshed > 0 && hasError) {
          this.$message.warning(`刷新中断，已获取${totalRefreshed}条数据，列表已更新`)
        } else if (!hasError) {
          this.$message.info('门锁列表已是最新')
        }
        
      } catch (error) {
        console.error('刷新过程错误:', error)
        if (loading && !loading.closed) {
          loading.close()
        }
        // 即使出错也重新加载列表
        await this.loadData()
        this.$message.warning('刷新中断，列表已更新')
      }
    },
    async searchEditShops(query) {
      this.editShopLoading = true
      try {
        const params = {
          name: query || undefined,
          page: 1,
          limit: 100,
          org_id:this.$globalConfig.orgId,
        }
        const res = await getShopList(params)
        
        if (res.code === 1) {
          // 处理可能的返回数据结构
          let shops = []
          if (Array.isArray(res.data)) {
            shops = res.data
          } else if (res.data && Array.isArray(res.data.data)) {
            shops = res.data.data
          } else if (res.data && Array.isArray(res.data.list)) {
            shops = res.data.list
          } else {
            shops = res.data || []
          }
          
          this.editShopOptions = shops
        } else {
          this.$message.error(res.msg || '获取店铺列表失败')
        }
      } catch (error) {
        this.$message.error('获取店铺列表失败')
      } finally {
        this.editShopLoading = false
      }
    },
    async handleEditShopChange(shopId) {
      if (shopId) {
        try {
          const res = await getRoomList({ shop_id: shopId })
          if (res.code === 1) {
            this.editRoomOptions = res.data || []
          } else {
            this.$message.error(res.msg || '获取包厢列表失败')
          }
        } catch (error) {
          this.$message.error('获取包厢列表失败')
        }
      } else {
        this.editRoomOptions = []
      }
    }
  }
}
</script>

<style scoped>
.lock-container {
  padding: 20px;
  background-color: #f5f5f5;
}

.search-bar {
  background: white;
  padding: 20px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.action-bar {
  background: white;
  padding: 20px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/views/device/Lock.vue